import { useMemo } from 'react'

import cn from 'classnames'

import { useConversationDetails } from '@app/hooks'

import { Avatar } from '@lib/components'

import { ListingPicture, PlainText } from '@lib/components'

import styles from './styles.module.scss'
import { ConversationListItemProps } from './types'
import { useListItem } from './useListItem'

export const ListItem = ({
  conversation,
  selected,
}: ConversationListItemProps) => {
  const {
    avatar,
    fullName,
    imageUrl,
    shouldUseLogoTemplate,
  } = useConversationDetails(conversation)
  const { date, message, handleConversationClick } = useListItem(conversation)

  const conversationListItemClassName = cn(styles.conversationListItem, {
    [styles.selected]: selected,
    [styles.unread]: conversation.unread,
  })

  const icon = useMemo(() => {
    if (imageUrl) {
      return <ListingPicture url={imageUrl} alt={fullName} />
    }

    return (
      <div className={styles.avatar}>
        <Avatar
          avatar={avatar}
          fullName={fullName}
          size="medium"
          template={shouldUseLogoTemplate ? 'logo-md' : 'user-sm'}
        />
      </div>
    )
  }, [avatar, fullName, imageUrl, shouldUseLogoTemplate])

  return (
    <div
      className={conversationListItemClassName}
      onClick={handleConversationClick}
    >
      {icon}
      <div className={styles.block}>
        <div className={styles.row}>
          <div className={styles.fullName}>{fullName}</div>
          <div className={styles.date}>{date}</div>
        </div>
        <div className={styles.subject}>
          <div className={styles.message}>
            <PlainText>{message}</PlainText>
          </div>
          <span className={styles.indicator} />
        </div>
      </div>
    </div>
  )
}
